import script from "./ReportTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReportTable.vue?vue&type=script&setup=true&lang=ts"

import "./ReportTable.vue?vue&type=style&index=0&id=1ff62704&scoped=true&lang=scss"
import "./ReportTable.vue?vue&type=style&index=1&id=1ff62704&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff62704"]])

export default __exports__